import { Injectable } from "@angular/core";
import { NtpeApi } from "src/app/api/observations/ntpe.api";
import { DateTimeDTO } from "src/app/model/date-time-dto.model";
import { CreateObservationDTO } from "src/app/model/observation/diff/diff-create-dto.model";
import { NTPERubricSaveDTO } from "src/app/model/observation/ntpe/ntpe-save-rubric-dto.model";
import { NtpeModel } from "src/app/model/observation/ntpe/ntpe.model";

@Injectable({
    providedIn: 'root'
})
export class NtpeService {
    constructor(private ntpeApi: NtpeApi) { }

    approveActionPlan = (observationId: string) =>
        this.ntpeApi.approveActionPlan(observationId);

    completeConference = (observationId: string, complete: boolean) =>
        this.ntpeApi.completeConference(observationId, complete);

    completePreConference = (observationId: string, complete: boolean) =>
        this.ntpeApi.completePreConference(observationId, complete);

    createNtpe = (createObservationDto: CreateObservationDTO) =>
        this.ntpeApi.createNtpe(createObservationDto);

    changeFocusArea = (ntpeObservationId: string, componentId: number, focused: boolean) =>
        this.ntpeApi.changeFocusArea(ntpeObservationId, componentId, focused);

    getObservationDetails = (observationId: any) =>
        this.ntpeApi.getDetails(observationId);

    save = (ntpeModel: NtpeModel) =>
        this.ntpeApi.save(ntpeModel);

    onSubmitActionPlan = (observationId: string) =>
        this.ntpeApi.onSubmitActionPlan(observationId);

    saveNTPERubric = (ntpeRubricSaveDTO: NTPERubricSaveDTO) =>
        this.ntpeApi.saveNTPERubric(ntpeRubricSaveDTO);

    scheduleConference = (observationId: string, date: DateTimeDTO) =>
        this.ntpeApi.scheduleConference(observationId, date);

    schedulePreConference = (observationId: string, date: DateTimeDTO) =>
        this.ntpeApi.schedulePreConference(observationId, date);

    submitFeedback = (observationId: string) =>
        this.ntpeApi.submitFeedback(observationId);

    submitUpdate = (ntpeRubricSaveDTO: NTPERubricSaveDTO) =>
        this.ntpeApi.submitUpdate(ntpeRubricSaveDTO);

    submitRating = (ntpeRubricSaveDTO: NTPERubricSaveDTO) =>
        this.ntpeApi.submitRating(ntpeRubricSaveDTO);

    submitSignature = (observationId: string, signature: string) =>
        this.ntpeApi.submitSignature(observationId, signature);

    unauthenticate = (observationId: string) =>
        this.ntpeApi.unauthenticate(observationId);

    approveMidYearUpdate = (observationId: string) =>
        this.ntpeApi.approveMidYearUpdate(observationId);

    submitMidYearUpdate = (ntpeRubricSaveDTO: NTPERubricSaveDTO) =>
        this.ntpeApi.submitMidYearUpdate(ntpeRubricSaveDTO);

    approveEndYearUpdate = (observationId: string) =>
        this.ntpeApi.approveEndYearUpdate(observationId);

    submitEndYearUpdate = (ntpeRubricSaveDTO: NTPERubricSaveDTO) =>
        this.ntpeApi.submitEndYearUpdate(ntpeRubricSaveDTO);
}